import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { FileUp } from 'lucide-react';

const ExcelImportSection = ({ excelFile, setExcelFile, handleExcelImport, importing, setShowGuide, language }) => (
  <div className="bg-white p-6 border border-stone-200 mb-6">
    <h3 className="text-stone-900 font-semibold mb-4 flex items-center gap-2">
      <FileUp className="w-5 h-5" /> {language === 'sv' ? 'Importera produkter från Excel' : 'Import products from Excel'}
    </h3>
    <div className="flex flex-col sm:flex-row gap-4">
      <Input type="file" accept=".xlsx,.xls" onChange={(e) => setExcelFile(e.target.files[0])} className="flex-1 bg-white border-stone-300" />
      <Button onClick={handleExcelImport} disabled={!excelFile || importing} className="bg-stone-900 text-white hover:bg-stone-800 rounded-none">
        {importing ? '...' : (language === 'sv' ? 'Importera' : 'Import')}
      </Button>
      <Button variant="outline" onClick={() => setShowGuide(true)} className="border-stone-300 rounded-none">
        {language === 'sv' ? 'Visa guide' : 'View guide'}
      </Button>
    </div>
  </div>
);


export default ExcelImportSection;
